import type { FC } from 'react';
import React, { useState } from 'react';

import styled from '@emotion/styled';

import { mq } from '@clutter/clean';

import type { PageQuery } from '@graphql/platform';

import { PageNavigation } from './navigation';
import {
  PAGE_ILLUSTRATIONS,
  PageContent,
  PageSectionText,
  PageSectionTitle,
} from './shared';

const PageExplanationsContainer = styled.div`
  display: flex;
  justify-content: center;

  ${mq({
    flexDirection: ['column', null, 'row'],
    alignItems: ['initial', null, 'center'],
    gap: ['36px', null, '80px'],
    padding: ['48px 24px', null, '60px 6px'],
  })}
`;

const PageExplanationsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-grow: 1;
  flex-shrink: 1;

  ${mq({
    order: [2, null, 1],
  })}
`;

const SectionLabel = styled.p`
  color: #4e4e4e;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: 'Basier Square';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin: 0;
`;

const PageExplanationsPhoto = styled.img`
  object-fit: cover;
  ${mq({
    width: ['100%', null, '512px'],
    height: ['233px', null, 'auto'],
    order: [1, null, 2],
    borderRadius: ['24px', null, '0'],
  })}
`;

export const PageExplanations: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  const [index, setIndex] = useState(0);
  const count = page.explanations.length;

  if (!count) return null;

  const current = page.explanations[index];

  return (
    <PageContent>
      <PageExplanationsContainer>
        <PageExplanationsContent>
          <SectionLabel>How does Clutter work?</SectionLabel>
          <PageSectionTitle>{current.title}</PageSectionTitle>
          <PageSectionText>{current.description}</PageSectionText>
          <PageNavigation count={count} index={index} onNavigate={setIndex} />
        </PageExplanationsContent>
        <PageExplanationsPhoto
          src={PAGE_ILLUSTRATIONS[current.illustration]}
          alt={current.alt}
          width={1024}
          height={1024}
        />
      </PageExplanationsContainer>
    </PageContent>
  );
};
